export const NEW_NOTICE = 'noticeStack/NEW_NOTICE';
export const REMOVE_NOTICE = 'noticeStack/REMOVE_NOTICE';
